import './personblock.less'

import {Background, Component, Icon, Image} from '@codeurs/front'
import {ImageType, LinkType} from 'types/types'

import Link from 'views/layout/link'
import cvicon from 'assets/icons/cvicon.png'
import m from 'mithril'

export type PersonBlockType = {
	name: string
	image?: ImageType
	function: string
	description: string
	linkedin?: string
	twitter?: string
	pdf?: LinkType
	email?: string
	phone?: string
	country: string
}

export default class PersonBlock extends Component<{
	block: PersonBlockType
	lists?: any
}> {
	view() {
		const {
			name,
			image,
			function: functionofperson,
			country,
			description,
			linkedin,
			twitter,
			pdf,
			email,
			phone
		} = this.attrs.block
		if (!name) return null
		return m('.personblock',
			m('.personblock-img',
				image &&
					m(Background, {
						img: image
					})
			),
			m('.personblock-info', [
				m('.personblock-info-top', [
					name && m('.personblock-info-top-name', name),
					country[0] &&
						this.getCountryCode(country[0]) &&
						m('.personblock-info-top-country',
							'(' + this.getCountryCode(country[0]).code + ')'
						)
				]),
				functionofperson && m('.personblock-info-function', functionofperson),
				description && m('.personblock-info-description', description),
				(email || phone) &&
					m('.personblock-info-contact', [
						email &&
							m('',
								m(Link,
									{
										href: 'mailto:' + email,
										mod: 'mailto',
										class: 'personblock-info-contact-link'
									},
									email
								)
							),
						phone &&
							m('',
								m(Link,
									{
										href: 'tel:' + phone,
										class: 'personblock-info-contact-link'
									},
									phone
								)
							)
					]),
				m('.personblock-info-links', [
					linkedin &&
						m('a.personblock-info-links-link.personblock-info-links-linkedin',
							{href: linkedin},
							m(Icon, {
								icon: 'linkedin',
								class: 'personblock-info-links-linkedin'
							})
						),
					twitter &&
						m('a.personblock-info-links-link.personblock-info-links-twitter',
							{href: twitter},
							m(Icon, {
								icon: 'twitter'
							})
						),
					pdf?.url &&
						m('a.personblock-info-links-link.personblock-info-links-cv',
							{href: pdf.url},
							m(Image, {
								src: cvicon,
								alt: 'PDF icon',
								class: 'personblock-info-links-cv-image'
							})
						)
				])
			])
		)
	}
	getCountryCode(country: string) {
		const {lists} = this.attrs
		if (country[0]) return lists.countries.find(x => x.id == parseInt(country))
	}
}
